import { TOLERANCE_SECTIONS } from '../../feeTolerance.constants';

const countSectionFees = section => {
  if (!section) {
    return 0;
  }

  const itemsCount = section.items?.length ?? 0;
  const groupsCount = (section.groups ?? []).reduce(
    (total, group) => total + (group.items?.length ?? 0) + (group.recordingFees?.length ?? 0),
    0,
  );

  return itemsCount + groupsCount;
};

export const hasAnyFees = (main = {}) =>
  TOLERANCE_SECTIONS.some(cdSection => countSectionFees(main[cdSection]) > 0);
